import hyperdom from 'hyperdom'
import {currentWidth, currentHeight} from './documentSizeUtils.js'

export default function repositionAbsoluteElement (target, delay) {
  return hyperdom.viewComponent({
    onadd (htmlDivElement) {
      setTimeout(() => positionElementInClientView(htmlDivElement), delay)
    },

    render () {
      return target
    },
  })
}

function positionElementInClientView (htmlDivElement) {
  const boundingRect = htmlDivElement.getBoundingClientRect()
  const clientHeight = currentHeight()
  const clientWidth = currentWidth()
  let currentTop = 0
  let currentLeft = 0

  const computedStyle = window.getComputedStyle(htmlDivElement)
  if (computedStyle.top.indexOf('px') > -1) {
    currentTop = parseInt(computedStyle.top.replace('px', ''), 10)
  }
  if (computedStyle.left.indexOf('px') > -1) {
    currentLeft = parseInt(computedStyle.left.replace('px', ''), 10)
  }

  if (boundingRect.top < 0) {
    htmlDivElement.style.top = `${Math.abs(boundingRect.top) + currentTop}px`
  }
  if (boundingRect.top > clientHeight || boundingRect.bottom > clientHeight) {
    htmlDivElement.style.top = `-${Math.min(boundingRect.top, boundingRect.bottom - clientHeight) + currentTop}px`
  }

  if (boundingRect.left < 0) {
    htmlDivElement.style.left = `${Math.abs(boundingRect.left) + currentLeft}px`
  }
  if (boundingRect.left > clientWidth || boundingRect.right > clientWidth) {
    htmlDivElement.style.left = `-${Math.min(boundingRect.left, boundingRect.right - clientWidth) + currentLeft}px`
  }

}